// Collapsible header toggle
  function mdTogglePanel() {
    var $ = window.jQuery || window.$;
    if (!$) return;

    var $content = $('#mdPanelContent');
    var $icon = $('#mdToggleIcon');

    if ($content.is(':visible')) {
      $content.slideUp(200);
      $icon.removeClass('md-open');
    } else {
      $content.slideDown(200);
      $icon.addClass('md-open');
    }
  }

  jQuery(function($) {
    var $panel = $('#md-bundle-panel');
    var $tabs = $panel.find('.md-tab-swatch');
    var $grid = $panel.find('.md-color-grid');
    var $totalPriceEl = $('#md-bundle-total-price');

    // --- Find product form + Add to Cart button -------------------------
    var formId = $panel.find('.child_variant_id').first().attr('form');
    var $productForm = formId ? $('#' + formId) : $panel.closest('form');
    var $addToCartBtn = $();

    if ($productForm && $productForm.length) {
      $addToCartBtn = $productForm.find(
        'button[type="submit"], input[type="submit"], .product-form__submit'
      ).first();
    }

    // --- Helpers --------------------------------------------------------

    function getNextEmptyTab() {
      return $tabs.filter('.color-tab--empty').first();
    }

    function setActiveTab($tab) {
      $tabs.removeClass('md-active');
      $tab.addClass('md-active');
      updateSwatchesAvailablity();
    }

    function allTabsFilled() {
      return $tabs.filter('.color-tab--empty').length === 0;
    }

    function areAllSlotsFilled() {
      return allTabsFilled();
    }

    function formatMoney(amount) {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(amount);
      }
      return (amount / 100).toFixed(2);
    }

    function updateBundleTotal() {
      var basePrice = 0;

      if (window.selected_variant && window.selected_variant.price) {
        basePrice = parseInt(window.selected_variant.price, 10) || 0;
      }

      var addOnTotal = 0;

      $panel.find('.child_variant_id').each(function() {
        var vId = $(this).val();
        if (vId) {
          var p = parseInt($(this).data('price'), 10);
          if (!isNaN(p)) {
            addOnTotal += p;
          }
        }
      });

      var total = basePrice + addOnTotal;
      $totalPriceEl.text(formatMoney(total));
    }

    function checkGridVisibility() {
      if (allTabsFilled()) {
        $grid.stop(true, true).slideUp();
      }
    }
    function findCurrentTotal(variantId){
      var total = 0;
      $(`.child_variant_id[value="${variantId}"]`).each(function(){
        var current = Number($(this).parents('.md-color-tab').find('.child_variant_quantity').val()) || 1;
        total = total + current;
      });
      console.log($(`.child_variant_id[value="${variantId}"]`), total);
      return total;
    }
    // Enable/disable Add to Cart + tooltip text
    function updateAddToCartState() {
      if (!$addToCartBtn.length) return;

      if (areAllSlotsFilled()) {
        $addToCartBtn
          .removeClass('md-atc-disabled')
          .prop('disabled', false)
          .removeAttr('title');
      } else {
        $addToCartBtn
          .addClass('md-atc-disabled')
          .prop('disabled', true)
          .attr('title', 'PLEASE SELECT ABOVE OPTION ALL');
      }
    }

    // --- Click on product in grid --------------------------------------

    $grid.on('click', '.md-color-option', function() {
      var $colorOption = $(this);
      var $swatch = $colorOption.find('.md-color-swatch');

      if ($swatch.hasClass('md-disabled')) {
        return;
      }

      var title  = $swatch.attr('title') || $colorOption.find('.md-color-name').text().trim();
      var variant = $swatch.attr('variant');
      var inventory = Number($swatch.attr('inventory'));
      var image   = $swatch.attr('image');
      var price   = parseInt($swatch.attr('price'), 10) || 0;

      var $activeTab = $tabs.filter('.md-active').first();
      if (!$activeTab.length) {
        $activeTab = $tabs.first();
        setActiveTab($activeTab);
      }
      var $tabWrapper = $activeTab.closest('.md-color-tab');
      var $inner = $activeTab.find('.md-swatch-inner');

      const color_quantity = Number($($tabWrapper).find('.child_variant_quantity').val());
      if(inventory < color_quantity){
        alert('Required inventory is less');
        return
      }

      // Fill current tab (remove empty state, apply image)
      $activeTab.removeClass('color-tab--empty');
      $inner
        .addClass('md-filled')
        .css({
          'background-image': 'url(' + image + ')',
          'background-size': 'cover',
          'background-position': 'center',
          'border': 'none'
        });

      // Store variant + price
      var $childInput = $tabWrapper.find('.child_variant_id');
      $childInput
        .val(variant)
        .data('price', price);
      
      // Update label + make it bold (selected)
      var $label = $tabWrapper.find('.md-tab-label');
      $label
        .text(title)
        .addClass('md-selected-label');

      // Move md-active to next empty tab (if any)
      var $nextEmpty = getNextEmptyTab();
      if ($nextEmpty.length) {
        setActiveTab($nextEmpty);
      } else {
        setActiveTab($activeTab);
      }

      updateBundleTotal();
      checkGridVisibility();
      updateAddToCartState();
      updateSwatchesAvailablity()

    });

    // --- Click on tab swatch (manual edit) ------------------------------

    $panel.on('click', '.md-tab-swatch', function() {
      var $tab = $(this);
      setActiveTab($tab);
      $grid.stop(true, true).slideDown();
    });

    // --- Clear all ------------------------------------------------------

    $panel.on('click', '.md-clear-all', function(e) {
      e.preventDefault();

      $tabs.each(function() {
        var $tab = $(this);
        var $wrap = $tab.closest('.md-color-tab');
        var $inner = $tab.find('.md-swatch-inner');

        // Return to empty state with PLUS icon
        $tab
          .addClass('color-tab--empty')
          .removeClass('md-active');

        $inner
          .removeClass('md-filled')
          .removeAttr('style'); // let CSS handle plus bg

        var $childInput = $wrap.find('.child_variant_id');
        $childInput
          .val('')
          .data('price', null);

        var $label = $wrap.find('.md-tab-label');
        var defaultTitle = $label.data('title') || 'Add product';
        $label
          .text(defaultTitle)
          .removeClass('md-selected-label'); // remove bold state
      });

      setActiveTab($tabs.first());
      $grid.stop(true, true).slideDown();
      updateBundleTotal();
      updateAddToCartState();
    });

    // --- Fix parent_id & validation right before submit -----------------

    // Runs before the theme sends anything to /cart/add. Returns true when
    // the submit must be blocked.
    function guardBundleSubmit(e) {
      if (!areAllSlotsFilled()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        alert('PLEASE SELECT ABOVE OPTION ALL');
        updateAddToCartState();
        return true;
      }

      // Make sure parent_id matches the main variant being added
      var currentParentId = $productForm.find('input[name="id"]').val();
      if (currentParentId) {
        $('.parent_variant_id').val(currentParentId);
      }
      return false;
    }

    if ($productForm && $productForm.length) {
      // The theme handles `on:submit` with a document-level CAPTURE listener
      // (component.js), which fires the /cart/add request before any listener
      // bound on the form itself runs. So the check has to live inside the
      // theme's own handleSubmit: wrap it on the component instance.
      var productFormComponent = $productForm.closest('product-form-component')[0];

      function wrapHandleSubmit(component) {
        if (!component || component.__mdBundleWrapped) return;
        var originalHandleSubmit = component.handleSubmit;
        if (typeof originalHandleSubmit !== 'function') return;

        component.handleSubmit = function(e) {
          if (guardBundleSubmit(e)) return;
          return originalHandleSubmit.apply(this, arguments);
        };
        component.__mdBundleWrapped = true;
      }

      if (productFormComponent && window.customElements) {
        customElements.whenDefined('product-form-component').then(function() {
          wrapHandleSubmit(productFormComponent);
        });
      }

      // Fallback for any submit path that bypasses the theme handler
      // (e.g. requestSubmit / Enter key when the theme JS failed to load).
      $productForm.on('submit.mdBundleFix', function(e) {
        if (productFormComponent && productFormComponent.__mdBundleWrapped) return;
        if (guardBundleSubmit(e)) return false;
      });

      // Extra safety: if user clicks disabled button, stop theme JS
      $addToCartBtn.on('click.mdBundle', function(e) {
        if ($(this).prop('disabled')) {
          e.preventDefault();
          e.stopImmediatePropagation();
          alert('PLEASE SELECT ABOVE OPTION ALL');
          return false;
        }
      });

      $addToCartBtn.on('mouseenter', function() {
        if (!areAllSlotsFilled()) {
          $(this).attr('title', 'PLEASE SELECT ABOVE OPTION ALL');
        }
      });
    }

    // --- Variant change hook (optional, for price only) -----------------

    $(document).on('mdvariant:change', function(e) {
      if (e.detail.variant) {
        window.selected_variant = e.detail.variant;
        $('.parent_variant_id').val(e.detail.variant.id);
        window.selected_color_quantity = window.color_quantity[window.selected_variant.id];
        $('.child_variant_quantity').each(function(index, item){
          $(this).val(window.selected_color_quantity[index])
        });
        $('.md-clear-all').click();
        updateBundleTotal();
      }
    });

    // The theme's product form re-enables the Add to Cart button on every
    // `variant:update` (product-form.js #onVariantUpdate calls enable() and
    // morphs the button from server HTML). That event bubbles, so re-apply
    // our state after the theme has finished.
    document.addEventListener('variant:update', function() {
      updateAddToCartState();
    });
    function updateSwatchesAvailablity(){
      const inventory_required = Number($('.md-tab-swatch.md-active').parents('.md-color-tab').find('.child_variant_quantity').val());
      $('.md-color-option').each(function(){
        var currentSelected = findCurrentTotal($(this).find('.md-color-swatch').attr('variant'));
        var inventory = Number($(this).find('.md-color-swatch').attr('inventory')) - currentSelected;
        if(inventory < inventory_required || $(this).find('.md-color-swatch').attr('unavailable') == 'false'){
          $(this).find('.md-color-swatch').addClass('md-disabled').find('.md-out-of-stock').show();
        }else{
          $(this).find('.md-color-swatch').removeClass('md-disabled').find('.md-out-of-stock').hide();
        }
      })
    }
    // Initial state
    updateBundleTotal();
    updateAddToCartState();
    updateSwatchesAvailablity()
  });